import Vue from 'vue';
import EntryForm from './EntryForm.vue';
import store from '../../lib/store';
import ConfigurationModeSwitch from './Configuration/ConfigurationModeSwitch';

export default function () {
  const entryFormEl = document.getElementById('entry-form');
  const configurationModeSwitchEl = document.getElementById('configuration-mode-switch');

  if (entryFormEl) {
    const form = new Vue({
      el: entryFormEl,
      components: {
        EntryForm
      },
      store
    });

    $(document).one('pjax:end', () => {
      form.$destroy();
    });
  }

  if (configurationModeSwitchEl) {
    const configurationModeSwitch = new Vue({
      el: configurationModeSwitchEl,
      components: {
        ConfigurationModeSwitch
      },
      store
    });

    $(document).one('pjax:end', () => {
      configurationModeSwitch.$destroy();
    });
  }
};
